export default {
    UPDATE_DEMOGRAPHICS_BEGIN :  'UPDATE_DEMOGRAPHICS_BEGIN',
    UPDATE_DEMOGRAPHICS_SUCCESS: 'UPDATE_DEMOGRAPHICS_SUCCESS',
    UPDATE_DEMOGRAPHICS_ERROR: 'UPDATE_DEMOGRAPHICS_ERROR',
    UPDATE_DEMOGRAPHICS_CLEANUP:'UPDATE_DEMOGRAPHICS_CLEANUP'
};